import * as React from 'react';

import { useSpontaneousCoverLetterEntryContext } from './spontaneous-apply-context';
import { ExitConfirmation } from '../../legacy';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface SpontaneousApplyCoverLetterLayoutProps {
  closeModal?: () => void;
  children: React.ReactNode;
}

// The header (back + close) now lives in the entry-point ModalContent's fixed header, so this
// layout only renders the scrollable body: either the exit-confirmation or the active section.
const SpontaneousApplyCoverLetterLayout: React.FunctionComponent<SpontaneousApplyCoverLetterLayoutProps> = ({
  closeModal,
  children,
}) => {
  const { isExitConfirmation, toggleExitConfirmation } = useSpontaneousCoverLetterEntryContext();

  return (
    <div className="flex flex-col gap-4 w-full">
      {isExitConfirmation ? (
        <ExitConfirmation
          onExitApplication={() => {
            if (closeModal) closeModal();
          }}
          onCancel={() => toggleExitConfirmation(false)}
        />
      ) : (
        children
      )}
    </div>
  );
};

export default SpontaneousApplyCoverLetterLayout;
